import { Register } from "@mosanic/auth";

const SignUp = ({}) => (
  <Register />
);
export default SignUp;
